<template>
  <v-container grid-list-xl fluid class="pt-0">

    <v-layout row wrap>
      <v-flex md2>
        <simple-date-picker :disabled="searched" v-model="filter.day" label="Fecha"></simple-date-picker>
      </v-flex>
      <v-flex md8 v-if='filter.day'>
        <v-select :disabled="searched" v-model="filter.employeeCompanyRut" :items="companies" item-text="employeeCompanyName" item-value="employeeCompanyRut" label="Empresa" hide-details></v-select>
      </v-flex>
      <v-flex md2 v-if='filter.employeeCompanyRut && companies.length > 0'>
        <v-btn color="primary" :disabled="searched" @click="getDailyData" flat>Continuar</v-btn>
      </v-flex>
    </v-layout>


    <v-toolbar v-if="searched" dark color="primary">
      <v-btn icon dark @click="searched = false; ">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex sm3>
          <v-text-field color="white" placeholder="xx.xxx.xxx-x" mask="##.###.###-N" v-on:keyup.enter="getDailyData" dark clearable hide-details label="Rut" v-model='filter.employeeRut'></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field color="white" placeholder="Nombre" v-on:keyup.enter="getDailyData" dark clearable hide-details label="Nombre" v-model='filter.employeeFullName'></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field color="white" placeholder="Cargo" v-on:keyup.enter="getDailyData" dark clearable hide-details label="Cargo" v-model='filter.employeeTitle'></v-text-field>
        </v-flex>
      </v-layout>
      <v-btn icon flat @click="getDailyData"><v-icon medium>search</v-icon></v-btn>
    </v-toolbar>


    <!-- table -->
    <v-data-table v-if="searched" :headers="headers" :items="items" :loading="loadingItems" class="elevation-1" rows-per-page-text='Mostrar' :rows-per-page-items="[10, 50]">
      <template v-slot:items="props">
        <td>{{ props.item.clientDate }}</td>
        <td>{{ props.item.eventCode }}</td>
        <td>{{ props.item.rut_formated }}</td>
        <td>{{ props.item.full_name }}</td>
        <td>{{ props.item.employeeTitle }}</td>
        <td v-if="props.item.geoLat && props.item.geoLong"><simple-map :ref="props.item.id" :zoom="15" :center="{lng : parseFloat(props.item.geoLong), lat : parseFloat(props.item.geoLat)}"></simple-map></td>
      </template>
      <template v-slot:footer>
        <td :colspan="4">
          <strong>{{items.length}} registros.</strong>
        </td>
      </template>
    </v-data-table>
    <!-- ./table -->


  </v-container>
</template>


<script>

import moment from 'moment'
import axios from 'axios';
import SimpleDatePicker from '@/components/app/datePicker';
import SimpleMap from '@/components/app/simpleMap.vue';

export default {
  components: {
    SimpleDatePicker,
    SimpleMap
  },
  data: () => ({
    searched : false,
    filter : {
      day : moment().format('YYYY-MM-DD')
    },
    items : [],
    loadingItems:false,
    headers: [
      { text: 'Fecha', value: 'clientDate' },
      { text: 'Tipo', value: 'eventCode' },
      { text: 'Rut', value: 'rut_formated' },
      { text: 'Nombre', value: 'full_name' },
      { text: 'Cargo', value: 'employeeTitle' },

    ],
    companies : [],
  }),
  watch: {
    'filter.day': {
      handler: function(val, oldVal) {
        if(val)
          this.getCompanies();
      },
      deep: true,
    },
  },
  mounted () {
    axios.defaults.headers.post['Accept'] = 'application/json';
    axios.defaults.baseURL = localStorage.getItem('ipApiServer');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    this.getCompanies();
  },
  methods: {
    getCompanies () {
      let $this = this;
      let params = Object.assign(this.filter);
      axios.get( 'admin/getDailyCompanies', { params : params } )
           .then( function(response){
             $this.companies = response.data;
             $this.filter.employeeCompanyRut = localStorage.getItem('defaultCompanyRut');
           })
           .catch(error => {
             if(error.response.status == 422){
               window.getApp.$emit('APP_BAD_REQUEST', error.response.data.message);
             }
           });
    },
    getDailyData(){
      this.searched = true;
      let $this = this;
      let params = Object.assign(this.filter);
      $this.loadingItems = true;
      axios.get( 'admin/getDailyRecords', { params : params } )
           .then( function(response){
             $this.items = response.data;
             $this.loadingItems = false;
             // $this.searched = true;
             // // $this.companies = response.data;
           })
           .catch(error => {
             if(error.response.status == 422){
               window.getApp.$emit('APP_BAD_REQUEST', error.response.data.message);
             }
           });
    }
  }

};

</script>
